import { BreakpointObserver, Breakpoints, BreakpointState } from "@angular/cdk/layout";
import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { filter, map, Observable } from "rxjs";
import { PadPhoto } from "../../data/pad-photo";
import { SpxLaunch } from "../../data/spx-launch";
import { CmsContentService } from "../../services/cms-content.service";
import { MissionService } from "../../services/mission-service";

const NUM_MISSIONS: number = 2;

@Component({
  selector: "upcoming-launch-widget",
  templateUrl: "./upcoming-launch-widget.component.html",
  styleUrls: ["./upcoming-launch-widget.component.scss", "./upcoming-launch-widget.component.mobile.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UpcomingLaunchWidget implements OnInit {
  public launches$: Observable<SpxLaunch[]>;
  public shouldShowTime$: Observable<boolean>;
  public padPhotos$: Observable<PadPhoto[]>;

  isMobile: boolean;

  constructor(
    readonly breakpointObserver: BreakpointObserver,
    private missionService: MissionService,
    private cmsContentService: CmsContentService) {
    this.launches$ = this.missionService.getUpcomingMissions(NUM_MISSIONS);
    this.shouldShowTime$ = this.launches$.pipe(map((launches: SpxLaunch[]) =>
      launches[0]?.timings.TZeroLaunchDate != null));
    this.padPhotos$ = this.cmsContentService.getPadPhotos().pipe(filter(photos => !!photos));
  }

  ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.Medium, Breakpoints.Small, Breakpoints.XSmall]).subscribe(
      (state: BreakpointState) => {
        this.isMobile = state.matches;
      });
  }


  getPadPhoto(launch: SpxLaunch, photos: PadPhoto[]): string {
    const launchSite: string = launch.launchSite.slice(0, launch.launchSite.indexOf(",")).toLowerCase();
    return photos.filter(photo => photo.padName == launchSite).map(photo => photo.imageDesktop.url)[0];
  }

  getTitle(launch: SpxLaunch) {
    if (launch.timings?.TZeroLaunchDate?.Seconds * 1000 < Date.now() && !launch.timings?.TZeroPaused) {
      return "Current Launch";
    }

    return "Upcoming Launches";
  }
}
